<template>
    <div class="admin-dashboard">
        <h1>Admin Dashboard</h1>
        <p>Welcome to the admin dashboard!</p>
        <p>There isn't really much to do here.</p>
        <!-- Blog Post Links for Verification -->
        <div class="blog-links">
            <h2>Blog Post Route Test Links</h2>
            <ul>
                <li>
                    <router-link to="/blog/why-spreadsheets-fail-reef-keepers">
                        /blog/why-spreadsheets-fail-reef-keepers
                    </router-link>
                </li>
                <li>
                    <router-link to="/blog/top-5-ways-to-keep-your-tank-stable">
                        /blog/top-5-ways-to-keep-your-tank-stable
                    </router-link>
                </li>
                <li>
                    <router-link to="/blog/best-reef-tank-log-app-free-and-paid-options-compared">
                        /blog/best-reef-tank-log-app-free-and-paid-options-compared
                    </router-link>
                </li>
                <li>
                    <router-link to="/blog/how-to-track-aquarium-parameters-without-expensive-controllers">
                        /blog/how-to-track-aquarium-parameters-without-expensive-controllers
                    </router-link>
                </li>
                <li>
                    <router-link to="/blog/top-10-most-important-reef-tank-parameters-to-monitor">
                        /blog/top-10-most-important-reef-tank-parameters-to-monitor
                    </router-link>
                </li>
                <li>
                    <router-link to="/blog/reef-tank-maintenance-schedule-template-free-download">
                        /blog/reef-tank-maintenance-schedule-template-free-download
                    </router-link>
                </li>
                <li>
                    <router-link to="/blog/spreadsheets-vs-apps-the-best-way-to-record-aquarium-data">
                        /blog/spreadsheets-vs-apps-the-best-way-to-record-aquarium-data
                    </router-link>
                </li>
                <li>
                    <router-link to="/blog/how-sharing-your-reef-tank-logs-can-help-the-community">
                        /blog/how-sharing-your-reef-tank-logs-can-help-the-community
                    </router-link>
                </li>
                <li>
                    <router-link to="/blog/beginners-guide-to-aquarium-parameter-logging">
                        /blog/beginners-guide-to-aquarium-parameter-logging
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { useHead } from '@vueuse/head';

useHead({
  title: 'Reeflendar.com - Admin Dashboard',
  meta: [
    { name: 'description', content: 'Admin dashboard for Reeflendar.' },
    { name: 'keywords', content: 'admin, dashboard, aquarium' },
  ],
});
</script>